import { RuntimeBaseError } from "@/domains/errors/kinds/RuntimeBaseError";

export class RuntimeNotImplementedError extends RuntimeBaseError {}
